export const MOTION_EASING = [0.19, 1, 0.22, 1] as const;

export const MOTION_DURATION = {
  fast: 0.3,
  base: 0.6,
  slow: 0.9,
} as const;

export const VIEWPORT_ONCE = {
  once: true,
  margin: '-80px 0px',
} as const;
